import React, { useState, useEffect } from 'react';
import { useShop } from '../context/ShopContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

// const API_BASE_URL = 'http://localhost:8080'; 
const API_BASE_URL = 'https://sardar-jewellers.com'; 

const CheckoutPage: React.FC = () => {
  // ✅ FIX: Yahan humne cartLoading ko bhi nikal liya
  const { cartItems, cartLoading } = useShop();
  const { user } = useAuth();
  const navigate = useNavigate();

  const [addresses, setAddresses] = useState<any[]>([]);
  const [selectedAddress, setSelectedAddress] = useState<number | null>(null);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [newAddress, setNewAddress] = useState({ fullName: '', mobileNo: '', streetAddress: '', city: '', state: '', pincode: '', addressType: 'Home' });
  const [paymentMethod, setPaymentMethod] = useState('cod');

  const totalAmount = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);

  // ✅ FIX: Wait for cartLoading to finish before kicking the user out!
  useEffect(() => {
    if (!user) navigate('/login');
    // Agar loading khatam ho gayi aur fir bhi cart empty hai, tab wapas bhejo
    // if (!cartLoading && cartItems.length === 0) navigate('/cart');
  }, [user, cartItems, cartLoading, navigate]);

  const fetchAddresses = async () => {
    if(user) {
      try {
        const res = await fetch(`${API_BASE_URL}/api/user-profile/address/${user.srNo}`);
        if(res.ok) {
          const data = await res.json();
          setAddresses(data);
          if(data.length > 0) setSelectedAddress(data[0].addressId);
          else setShowAddressForm(true); 
        }
      } catch (err) { console.error("Error fetching addresses", err); }
    }
  };

  useEffect(() => { fetchAddresses(); }, [user]);

  const handleSaveAddress = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
        const payload = { ...newAddress, userSrno: user?.srNo };
        const res = await fetch(`${API_BASE_URL}/api/user-profile/address/add`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        });
        if(res.ok) {
            fetchAddresses(); 
            setShowAddressForm(false);
        }
    } catch (err) { console.error("Failed to save address", err); }
  };

  const handlePlaceOrder = async () => {
    if(!selectedAddress) return alert("Please select a delivery address.");
    
    try {
      const payload = {
        userSrno: user?.srNo,
        addressId: selectedAddress
      };

      const res = await fetch(`${API_BASE_URL}/api/orders/place`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if(res.ok) {
        navigate('/orders'); // Order success page
      } else {
        alert("Failed to place order. Please try again.");
      }
    } catch (err) {
      console.error("Order placed error", err);
    }
  };

  // ✅ FIX: Show loading state so it doesn't flash
  if (!user || cartLoading) return <div className="min-h-screen flex items-center justify-center text-xl font-bold text-amber-800">Loading Secure Checkout...</div>;

  return (
    <div className="container mx-auto px-4 py-10 min-h-screen bg-gray-50">
      <h1 className="text-3xl font-extrabold mb-8 text-gray-900">Secure Checkout</h1>
      
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left Side: Address & Payment */}
        <div className="lg:col-span-2 space-y-6">
          {/* 1. Delivery Address Section */}
          <div className="p-6 border rounded-xl shadow-sm bg-white">
            <div className="flex justify-between items-center border-b pb-4 mb-4">
                <h2 className="text-xl font-bold text-gray-800">1. Delivery Address</h2>
                {!showAddressForm && (
                    <button onClick={() => setShowAddressForm(true)} className="text-amber-700 font-semibold hover:underline">+ Add New</button>
                )}
            </div>

            {!showAddressForm && addresses.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {addresses.map(addr => (
                  <label key={addr.addressId} className={`p-4 border rounded-lg cursor-pointer transition-all ${selectedAddress === addr.addressId ? 'border-amber-600 bg-amber-50 ring-1 ring-amber-600' : 'hover:border-gray-400'}`}>
                    <div className="flex items-start gap-3">
                      <input type="radio" name="address" checked={selectedAddress === addr.addressId} onChange={() => setSelectedAddress(addr.addressId)} className="mt-1 text-amber-600 focus:ring-amber-500" />
                      <div>
                        <p className="font-bold text-gray-900">{addr.fullName} <span className="text-xs bg-gray-200 px-2 py-0.5 rounded ml-2">{addr.addressType}</span></p>
                        <p className="text-sm text-gray-600 mt-1">{addr.streetAddress}, {addr.city}</p>
                        <p className="text-sm text-gray-600">{addr.state} - {addr.pincode}</p>
                        <p className="text-sm text-gray-600 mt-1 font-medium">Phone: {addr.mobileNo}</p>
                      </div>
                    </div>
                  </label>
                ))}
              </div>
            )}

            {showAddressForm && (
              <form onSubmit={handleSaveAddress} className="bg-gray-50 p-5 rounded-lg border">
                <h3 className="font-semibold text-gray-800 mb-4">Enter New Address</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input type="text" placeholder="Full Name" required className="p-2.5 border rounded" onChange={e => setNewAddress({...newAddress, fullName: e.target.value})} />
                  <input type="tel" placeholder="Mobile Number" required className="p-2.5 border rounded" onChange={e => setNewAddress({...newAddress, mobileNo: e.target.value})} />
                  <input type="text" placeholder="Pincode" required className="p-2.5 border rounded" onChange={e => setNewAddress({...newAddress, pincode: e.target.value})} />
                  <input type="text" placeholder="City" required className="p-2.5 border rounded" onChange={e => setNewAddress({...newAddress, city: e.target.value})} />
                  <input type="text" placeholder="State" required className="p-2.5 border rounded" onChange={e => setNewAddress({...newAddress, state: e.target.value})} />
                  <div className="md:col-span-2">
                    <textarea placeholder="Full Street Address" required rows={2} className="w-full p-2.5 border rounded" onChange={e => setNewAddress({...newAddress, streetAddress: e.target.value})}></textarea>
                  </div>
                </div>
                <div className="mt-4 flex gap-3">
                    <button type="submit" className="bg-gray-800 text-white px-5 py-2 rounded hover:bg-gray-900">Save & Deliver Here</button>
                    {addresses.length > 0 && <button type="button" onClick={() => setShowAddressForm(false)} className="text-gray-600 px-4">Cancel</button>}
                </div>
              </form>
            )}
          </div>

          {/* 2. Payment Method Section */}
          <div className="p-6 border rounded-xl shadow-sm bg-white">
            <h2 className="text-xl font-bold text-gray-800 border-b pb-4 mb-4">2. Select Payment Method</h2>
            <div className="space-y-3">
              <label className="flex items-center p-4 border rounded-lg cursor-pointer hover:bg-gray-50 transition">
                <input type="radio" name="payment" value="cod" checked={paymentMethod === 'cod'} onChange={() => setPaymentMethod('cod')} className="h-5 w-5 text-amber-600 focus:ring-amber-500" />
                <span className="ml-3 font-medium text-gray-900">Cash on Delivery (COD)</span>
              </label>

              <div className="relative group">
                  <label className="flex items-center p-4 border rounded-lg cursor-not-allowed bg-gray-50 opacity-60">
                    <input type="radio" name="payment" value="upi" disabled className="h-5 w-5 text-gray-400" />
                    <span className="ml-3 font-medium text-gray-500 flex items-center gap-2">
                        UPI / Credit Card 
                        <span className="text-xs bg-red-100 text-red-600 px-2 py-0.5 rounded font-bold">Maintenance</span>
                    </span>
                  </label>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side: Order Summary */}
        <div className="lg:col-span-1 p-6 border rounded-xl bg-white shadow-sm h-fit sticky top-28">
          <h2 className="text-xl font-bold mb-4 border-b pb-3 text-gray-800">Order Summary</h2>
          <div className="space-y-3 mb-6 max-h-60 overflow-y-auto scrollbar-hide">
            {cartItems.map((item) => (
              <div key={item.cartId} className="flex justify-between text-sm items-center">
                <span className="text-gray-600 truncate mr-2 pr-2">
                  <span className="font-semibold text-gray-800">{item.quantity}x</span> {item.productTitle}
                </span>
                <span className="font-medium min-w-[60px] text-right">₹{(item.price * item.quantity).toFixed(2)}</span>
              </div>
            ))}
          </div>

          <div className="border-t pt-4 space-y-2 text-sm text-gray-600">
             <div className="flex justify-between"><span>Subtotal</span><span>₹{totalAmount.toFixed(2)}</span></div>
             <div className="flex justify-between"><span>Shipping</span><span className="text-green-600 font-semibold">FREE</span></div>
          </div>

          <div className="flex justify-between border-t mt-4 pt-4 text-xl font-extrabold text-gray-900">
            <span>Grand Total</span>
            <span className="text-amber-700">₹{totalAmount.toFixed(2)}</span>
          </div>

          <button
            onClick={handlePlaceOrder}
            disabled={!selectedAddress}
            className={`w-full mt-6 py-3.5 rounded-lg font-bold shadow-md transition duration-300 ${selectedAddress ? 'bg-amber-700 text-white hover:bg-amber-800' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}
          >
            {selectedAddress ? 'Place Order' : 'Select Address First'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;